import { useNavigate } from 'react-router-dom';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { ConstructionSite } from '../../../classes/entities/ConstructionSite/constructionSiteTypes';
import { useConstructionSiteUsageStatisticTools } from '../../../classes/entities/ConstructionSiteUsageStatistic/useConstructionSiteUsageStatisticTools';
import { RoutePaths } from '../../../classes/RoutePaths/RoutePaths';
import { useAppDispatch } from '../../../store/hooks';
import { createWorkTimeEntrySlice } from '../../../store/slice/createWorkTimeEntry/createWorkTimeEntrySlice';
import { ConstructionSiteToSelectListItemProps } from '../../constructionSite/ConstructionSiteToSelectListItem/ConstructionSiteToSelectListItem';

export function useConstructionSiteSelectedHandler(): {
  handleConstructionSiteSelected: (constructionSite: ConstructionSite) => void;
} {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const usageStatisticTools = useConstructionSiteUsageStatisticTools();

  const handleConstructionSiteSelected: ConstructionSiteToSelectListItemProps['onConstructionSiteSelected'] =
    useEventCallback((constructionSite) => {
      usageStatisticTools.usedConstructionSite(constructionSite);
      dispatch(
        createWorkTimeEntrySlice.actions.setConstructionSiteId(
          constructionSite.id
        )
      );
      navigate(RoutePaths.createWorkTimeEntry());
    });

  return { handleConstructionSiteSelected };
}
